import { BiCalendarExclamation } from 'react-icons/bi'
import { FiBarChart2 } from 'react-icons/fi'
import { ImStack } from 'react-icons/im'
import { BsClipboardData } from 'react-icons/bs'
import { RiGitRepositoryLine } from 'react-icons/ri'
import { HiChartPie } from 'react-icons/hi'
import { TiClipboard, TiFlowChildren } from 'react-icons/ti'
import { IoIosCalendar } from 'react-icons/io'
import { MdFolderOpen } from 'react-icons/md'

export const SidebarOptions = [
	// {
	// 	name: 'Search',
	// 	icon: IoIosCalendar,
	// 	pathname: '',
	// },
	{
		name: 'Calendar',
		icon: IoIosCalendar,
		pathname: '',
	},
	{
		name: 'Focus List',
		icon: FiBarChart2,
		pathname: '/focus',
		isBadge: true,
		key: 'count_focus',
	},
	{
		name: 'Delayed',
		icon: FiBarChart2,
		pathname: '/delayed',
		isBadge: true,
		key: 'count_pastdue',
	},
	{
		name: 'Mentions',
		icon: FiBarChart2,
		pathname: '/mentions',
		isBadge: true,
		key: 'count_mention',
	},
	{
		name: 'Updates',
		icon: FiBarChart2,
		pathname: '/updates',
		isBadge: true,
		key: 'count_unread',
	},
	{
		name: 'New Request',
		icon: FiBarChart2,
		pathname: '',
	},
	{
		name: 'Queues',
		icon: TiClipboard,
		pathname: '',
	},
	{
		name: 'Requests',
		icon: BsClipboardData,
		pathname: '/requests',
	},
	{
		name: 'Chats',
		icon: MdFolderOpen,
		pathname: '/chats',
		isBadge: true,
		key: 'count_chat',
	},
	{
		name: 'Doc Repository',
		icon: TiFlowChildren,
		pathname: '',
	},
	{
		name: 'Dashboard',
		icon: FiBarChart2,
		pathname: '',
	},
	// {
	// 	name: 'Web Access',
	// 	icon: FiBarChart2,
	// 	pathname: '',
	// },
	// {
	// 	name: 'Preferences',
	// 	icon: FiBarChart2,
	// 	pathname: '',
	// },
]
